import React from 'react';

import moment from 'moment';

import { DocumentSpecifiqueDto } from 'lib_api/lib/api/gen';

import FileCard from 'components/FileCard/FileCard';
import useDownloadDocumentSpecifique from 'hooks/referentiels/DocumentSpecifique/useDownloadDocumentSpecifique';
import { getIconFromImageName } from 'utils/ImageIconsUtils';

import './DocumentSpecifiqueCard.less';

interface DocumentSpecifiqueCardProps {
  document: DocumentSpecifiqueDto;
  isAdmin?: boolean;
  onDelete?: (document: DocumentSpecifiqueDto) => void;
}

function DocumentSpecifiqueCard({
  document,
  isAdmin,
  onDelete,
}: DocumentSpecifiqueCardProps): React.ReactElement {
  const { download } = useDownloadDocumentSpecifique();

  function onClick() {
    return download(document.name, document.hash);
  }

  function handleDelete() {
    onDelete && onDelete(document);
  }

  const description = (
    <div>
      <p className="multilineDescription">
        Importé le {moment(document.creationDate).format('DD-MM-YYYY')}
      </p>
      <p className="multilineDescription">
        Destinataire: {document.utilisateurDestinataire}
      </p>
    </div>
  );

  const icon = getIconFromImageName(document.name);

  if (isAdmin) {
    return (
      <FileCard
        download={onClick}
        icon={icon}
        title={document.name}
        description={description}
        onDelete={handleDelete}
      />
    );
  }

  return (
    <FileCard
      download={onClick}
      icon={icon}
      title={document.name}
      description={`Importé le ${moment(document.creationDate).format(
        `YYYY-MM-DD`,
      )}`}
    />
  );
}

export default DocumentSpecifiqueCard;
